var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.502,
    viewBox: "0 0 19.5 19.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard-svgrepo-com",
    transform: "translate(0.75 0.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6771",
    "data-name": "Path 6771",
    d: "M11.344,10H7.592a2.171,2.171,0,0,0-1.473.549A1.842,1.842,0,0,0,5.5,11.9v7.179a2,2,0,0,0,2.092,1.9h3.751a2.171,2.171,0,0,0,1.473-.549,1.842,1.842,0,0,0,.62-1.348V11.9a1.842,1.842,0,0,0-.62-1.348A2.172,2.172,0,0,0,11.344,10Z",
    transform: "translate(-5.5 -2.973)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6772",
    "data-name": "Path 6772",
    d: "M11.344,4H7.592A1.973,1.973,0,0,0,5.5,5.821V7.057a1.973,1.973,0,0,0,2.092,1.82h3.751a1.973,1.973,0,0,0,2.092-1.82V5.821A1.973,1.973,0,0,0,11.344,4Z",
    transform: "translate(-5.5 -4)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    "data-name": "Path 6773",
    d: "M15.592,14.972h3.75a2.171,2.171,0,0,0,1.473-.549,1.843,1.843,0,0,0,.62-1.348V5.9a1.842,1.842,0,0,0-.62-1.348A2.171,2.171,0,0,0,19.344,4H15.592a2.171,2.171,0,0,0-1.473.549A1.842,1.842,0,0,0,13.5,5.9v7.178a1.842,1.842,0,0,0,.62,1.348A2.172,2.172,0,0,0,15.592,14.972Z",
    transform: "translate(-3.436 -4)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6774",
    "data-name": "Path 6774",
    d: "M15.592,19.877h3.75a1.973,1.973,0,0,0,2.094-1.82V16.821A1.973,1.973,0,0,0,19.344,15H15.592a1.973,1.973,0,0,0-2.092,1.82v1.235A1.973,1.973,0,0,0,15.592,19.877Z",
    transform: "translate(-3.436 -1.878)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.89cee29622a7b296e7f64953df9770c3.svg";
export { ForwardRef as ReactComponent };